(function () {
    'use strict';

    angular.module("imApp").factory("oeeStateEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 241,
                    parameters: parms || {}
                });
            },
            listColours: function (parms) {
                return $ihttp.post({
                    method: 255,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 242,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
